import { render, staticRenderFns } from "./stockAffirmDialog.vue?vue&type=template&id=24566215&scoped=true"
import script from "./stockAffirmDialog.vue?vue&type=script&lang=js"
export * from "./stockAffirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24566215",
  null
  
)

export default component.exports